import { MDBAlert, MDBBtn, MDBCard, MDBCardBody, MDBChart, MDBCol, MDBDatatable, MDBIcon, MDBRow, MDBSpinner } from 'mdb-react-ui-kit';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router";
import { Tooltip } from 'react-tooltip';
import { getAccountStorage, updateStorageAutoPurchase } from '../../../apiclients/streamsapi_bridge';
import PopupLoaderNew from '../../../views/popups/PopupLoaderNew';
import DeleteStorage from '../../../views/popups/accountstoragemanager/DeleteStorage';
import StoragePurchased from '../../../views/popups/accountstoragemanager/StoragePurchased';
import SaveChanges from '../saveCancel';
import TabIDConstant from '../../../apiclients/TabIDConstant';
function StorageManager({ setEdited }) {
    const { t, i18n } = useTranslation();
    const [purchaseStorage, setPurchaseStorage] = useState(false);
    const purchaseStorageOpen = () => setPurchaseStorage(!purchaseStorage);
    const [isloading, setIsloading] = useState(false);
    const [internalError, setInternalError] = useState(false);
    const [storageDetails, setstorageDetails] = useState([])
    const navigate = useNavigate();
    const [callRecording, setcallRecording] = useState({});
    const [connectRecording, setconnectRecording] = useState({});
    const [isAutoPurchased, setisAutoPurchased] = useState(false);
    const [isDefaultAutoPurchased, setisDefultAutoPurchased] = useState(false);
    const [displySave, setDisplaySave] = useState(false);
    const [rerender, setrerender] = useState(true);
    const [successMessage, setSuccessMessage] = useState("");
    const [isCallRecording, setIsCallRecording] = useState(false);
    const [storageObj, setstorageObj] = useState({});
    const [deleteStorage, setdeleteStorage] = useState(false)
    const handleDelete = () => setdeleteStorage(!deleteStorage);
    const storagePurchaseref = useRef(null);
    const [isLoading, setisLoading] = useState(false);

    function handleClick() {
        storagePurchaseref.current.click();
    }


    useEffect(() => {
        if (successMessage) {
            setTimeout(() => {
                setSuccessMessage(""); // Clear the success message in the parent component
            }, 5000);
        }
    }, [successMessage]);


    async function fetchStorageDetails() {
        try {
            setIsloading(true);
            setInternalError(false);
            const response = await getAccountStorage(JSON.parse(
                sessionStorage.getItem("admin_session")
            ).siteid,
            TabIDConstant.ACC_SETT_SETTINGS_SUBLINK
        );
            const rawData = await response.json();
            console.log("Storage details :::::: " + JSON.stringify(rawData));
            if (response.status === 200) {
                setstorageDetails(rawData?.storageDtls ?? []);
                // setcallRecording(rawData?.storageDtls[0] ?? {});
                // setconnectRecording(rawData?.storageDtls[1] ?? {});
                if (rawData?.storageDtls[0]) {
                    const autopurchase = (rawData?.storageDtls[0]).auto_purchase;
                    setisAutoPurchased(autopurchase === "Yes" ? true : false);
                    setisDefultAutoPurchased(autopurchase === "Yes" ? true : false);
                }
            } else if (response.status === 500) {
                setInternalError(true);
            } else {
                navigate("/");
            }
        } catch (e) {
            console.log(`Unable to process the request:${e}`);
            setInternalError(true);
        } finally {
            setIsloading(false);
        }

    }

    useEffect(() => {
        if (rerender) {
            fetchStorageDetails();
            setrerender(false);
        }
    }, [rerender]);

    async function handleChange(e, storageObj) {
        setisAutoPurchased(e.target.checked);
        if (isDefaultAutoPurchased !== e.target.checked) {
            setDisplaySave(true);

        } else {
            setDisplaySave(false);
        }

    }

    const handlePurchase = (event, storage) => {
        event.preventDefault();
        if (storage.auto_purchase) {
            setIsCallRecording(true);
        } else {
            setIsCallRecording(false);
        }
        setstorageObj(storage);
        purchaseStorageOpen();

    }


    const handleToDelete = (event, storage) => {
        event.preventDefault();
        if (storage.auto_purchase) {
            setIsCallRecording(true);
        } else {
            setIsCallRecording(false);
        }
        setstorageObj(storage);
        handleDelete();

    }


    let proccessdRows = [];
    storageDetails.map((storage) => {

        proccessdRows.push({
            storageInfo: storage,
            addon: storage.addon_name,
            purchased: storage.purchased,
            used: storage.used,
            avaliable: storage.available,
            included: storage.included,
            fid: storage.fid,
            auto_purchase_flag: storage.auto_purchase,
            autoPurchase: ((storage.auto_purchase && storage.auto_purchase_visible) && (

                <>
                    <div className=" ">
                        <label className="switch">
                            <input
                                className="form-control"
                                type="checkbox"
                                checked={isAutoPurchased}
                                onChange={(e) => handleChange(e, storage)}
                            />
                            <span className="slider round"></span>
                        </label>
                    </div>
                </>
            )),

            actions: (
                <>
                    <div className="d-flex align-items-center justify-content-center">
                        <div onClick={(e) => handlePurchase(e, storage)} className="custom-hover-bg p-1 px-2 cursor-pointer AddToolTip">
                            <MDBIcon className="fs-5" fas icon="plus" color="primary" />
                        </div>
                        <div onClick={(e) => handleToDelete(e, storage)} className="custom-hover-bg ms-2 px-2 p-1 cursor-pointer deleteToolTip">
                            <MDBIcon className="fs-5" fas icon="times" color="primary" />
                        </div>
                    </div>
                </>
            ),
        });
    });


    const finalData = {
        columns: [
            { label: 'Add-ons', field: 'addon' },
            { label: 'Purchased', field: 'purchased' },
            { label: 'Used', field: 'used' },
            { label: 'Available', field: 'avaliable' },
            { label: 'Included', field: 'included', sort: false },
            { label: 'Auto Purchase', field: 'autoPurchase', sort: false },
            { label: 'Actions', field: 'actions', sort: false },
        ],
        rows: proccessdRows,
    };


    function closeSave(e) {
        setisAutoPurchased(isDefaultAutoPurchased);
        setDisplaySave(false);
    }

    useEffect(() => {
        setEdited(displySave);
    }, [displySave])

    async function onSubmit() {
        try {
            if (displySave) {
                const update = {
                    siteid: JSON.parse(
                        sessionStorage.getItem("admin_session")
                    ).siteid,
                    auto_purchase_flag: isAutoPurchased ? 1 : 0,
                }

                console.log("update autopurchase ::::: " + JSON.stringify(update));

                let saverep = await updateStorageAutoPurchase(update);
                console.log(saverep);
                let saverepeMsg = await saverep.json();
                console.log("response autopurchase ::::: " + JSON.stringify(saverepeMsg))
                //alert(saverepeMsg.status);
                if (saverepeMsg.status && saverepeMsg.status == "success") {
                    setSuccessMessage(saverepeMsg.message);
                    setrerender(true);
                    setDisplaySave(false);



                } else {
                    // if (saverepeMsg.message?.errors) {
                    //     saverepeMsg.message.errors.forEach((err) => {
                    //         if(err.param_name === "logined_user"){
                    //             props.setErrorMessage(err.message)
                    //             reset();
                    //         }
                    //         setError(err.param_name, {
                    //           type: "server",
                    //           message: err.message,
                    //         });
                    //         const fieldElement = document.querySelector(
                    //           `input[name="${err.param_name}"]`
                    //         );
                    //         if (fieldElement) {
                    //           fieldElement.focus();
                    //           //fieldElement.scrollIntoView({ behavior: "smooth" });
                    //         }
                    //       });
                    // }


                }
            }

        } catch (error) {

        }

    }
    const [selectedColorTheme, setSelectedColorTheme] = useState('light'); // Default to 'light' or any other default value
    const prefersDarkMode = window.matchMedia("(prefers-color-scheme: dark)");

    useEffect(() => {
        const theme = localStorage.getItem('selectedColorTheme');
        if (theme === "light" || theme === "dark") {
            setSelectedColorTheme(theme);
        } else {
            setSelectedColorTheme(prefersDarkMode.matches === true ? "dark" : "light");
        }
        console.log(prefersDarkMode, "prefersDarkMode")
        console.log(theme + "##############");
    }, []);


    useEffect(() => {
        const patchTitles = () => {
            const tds = document.querySelectorAll('table td');
            tds.forEach(td => {
                const trimmed = td.textContent.trim();
                if (trimmed && td.getAttribute('title') !== trimmed) {
                    td.setAttribute('title', trimmed);
                }
            });
        };

        const observer = new MutationObserver(() => {
            patchTitles();
        });

        const observeTable = () => {
            const table = document.querySelector('.usersData-Table');
            if (table) {
                observer.observe(table, {
                    childList: true,
                    subtree: true,
                });
                patchTitles(); // Initial patch
            }
        };

        const timeout = setTimeout(observeTable, 300);

        return () => {
            observer.disconnect();
            clearTimeout(timeout);
        };
    }, []);



    return (
        <>
            {/* <div className="general-settings">Storage Manager</div> */}
            <div className="mt-0 px-2 pb-5">
                <MDBRow>
                    {storageDetails && storageDetails.length > 0 && storageDetails.map((storage) => (
                        <MDBCol md={12} lg={6} sm={12} className='mb-3' key={storage.fid}>
                            <MDBCard className="custom-border" style={{ minHeight: "250px" }}>
                                <MDBCardBody>
                                    <div className="d-flex align-items-center">
                                        <div className="w-40 py-4" >
                                            <MDBChart
                                                type='pie'
                                                datalabels="false"
                                                data={{
                                                    labels: [' Used', ' Available'],
                                                    datasets: [
                                                        {
                                                            label: 'Traffic',
                                                            data: [
                                                                (storage.used ? parseFloat(storage.used.split(" ")[0]).toFixed(2) : '0.00'),
                                                                (storage.available ? parseFloat(storage.available.split(" ")[0]).toFixed(2) : '0.00')
                                                            ],
                                                            backgroundColor: ['#1e80cb', '#00b9ff'],
                                                            borderWidth: 0, // Remove white default border
                                                        },
                                                    ],
                                                }}
                                                options={{
                                                    plugins: {
                                                        datalabels: {
                                                            color: selectedColorTheme === "light" ? '#000000' : '#FFFFFF',
                                                            font: {
                                                                size: 14,
                                                            },
                                                            formatter: (value, context) => {
                                                                const label = context.chart.data.labels[context.dataIndex];
                                                                // Add a line break before the second label to prevent overlap
                                                                if (context.dataIndex === 1) {
                                                                    return `${label}: ${value}`;
                                                                }
                                                                return `\n\n${label}: ${value}`;
                                                            },
                                                        },
                                                        legend: {
                                                            display: false,
                                                        },
                                                    }
                                                }}
                                            />

                                        </div>
                                        <div className="ps-2">
                                            <h4 className="text-primary">{storage.addon_name ? storage.addon_name.split("-")[0.00].trim() : ""}</h4>
                                            <h3 className="text-primary fw-bold">{storage.purchased}</h3>
                                            <p className="fs-4">Purchased</p>
                                            <div className="">
                                                <p>Included: {storage.included}</p>
                                                {storage.auto_purchase && (
                                                    <p>Auto-Purchase: {storage.auto_purchase}</p>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </MDBCardBody>
                            </MDBCard>
                        </MDBCol>
                    ))}


                </MDBRow>

                <div className='storage-manager-dataTable'>
                    {/* <MDBDatatable pagination={false} hover data={finalData}
                        sortField="Add-ons" className='actioncolumnbig'
                        
                        /> */}

                    <MDBDatatable
                        pagination={false}
                        hover
                        data={finalData}
                        sortField="Add-ons"
                        className='actioncolumnbig usersData-Table'
                        onRendered={() => {
                            const tds = document.querySelectorAll('table td');
                            tds.forEach(td => {
                                const trimmed = td.textContent.trim();
                                if (trimmed && td.getAttribute('title') !== trimmed) {
                                    td.setAttribute('title', trimmed);
                                }
                            });
                        }}
                    />

                </div>
                {displySave && (
                    <SaveChanges
                        onClose={closeSave}
                        isdirtyFields={displySave}
                        onSave={(e) => {
                            e.preventDefault();
                            onSubmit();
                        }}
                    />
                )}
            </div>

            {purchaseStorage && (
                <PopupLoaderNew
                    title={isCallRecording ? "Purchase Call Recording Storage" : "Purchase Connect Recording Storage"}
                    content={
                        <div className='overflow-visible'>
                            <StoragePurchased
                                onClose={purchaseStorageOpen}
                                storageObj={storageObj}
                                setSuccessMessage={setSuccessMessage}
                                setrerender={setrerender}
                                ref={storagePurchaseref}
                                setIsloading={setisLoading}
                            />
                        </div>
                    }
                    onShow={setPurchaseStorage}
                    onClose={purchaseStorageOpen}
                    onSave={handleClick}
                    isloading={isLoading}
                    flag={2}
                />
            )}
            {deleteStorage && (
                <PopupLoaderNew
                    title={isCallRecording ? "Remove Call Recording Storage" : "Remove Connect Recording Storage"}
                    content={<DeleteStorage
                        storageObj={storageObj}
                        setSuccessMessage={setSuccessMessage}
                        setrerender={setrerender}
                        onClose={handleDelete}
                        ref={storagePurchaseref}
                        setIsloading={setisLoading}
                    />}
                    onShow={setdeleteStorage}
                    onClose={handleDelete}
                    onSave={handleClick}
                    isloading={isLoading}
                    flag={4}
                />
            )}

            {isloading && (
                <>
                    <div className="loadingclass">
                        <MDBBtn disabled>
                            <MDBSpinner
                                size="sm"
                                role="status"
                                tag="span"
                                className="me-2"
                            />
                            Loading...
                        </MDBBtn>
                    </div>
                </>
            )}

            {successMessage && (
                <MDBAlert
                    open
                    className="alert-center"
                    color="success"
                    autohide
                    position="bottom-right"
                    delay={10000}
                >
                    <i className="fas fa-check-circle me-3"></i>
                    <span className="alert-msg">{successMessage}</span>
                </MDBAlert>
            )}
            <Tooltip anchorSelect=".AddToolTip" place="top" className="exampleTooltip">
                Purchase
            </Tooltip>
            <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
                Delete
            </Tooltip>
        </>
    )
}

export default StorageManager
